// src/pages/Login.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [userid, setuserid] = useState("");
  const [inputpwd, setInputpwd] = useState("");
  const [loading, setLoading] = useState(false);




  useEffect(() => {
    // Ensure preloader never lingers when we land on login
    const t = setTimeout(() => { if (window.hidePreloader) window.hidePreloader(); }, 250);
    return () => clearTimeout(t);
  }, []);

  return (
    // same JSX UI as version A (omitted here for brevity) - use the same markup you prefer
    // you can copy the markup from version A; behavior remains the same
    <div className="hold-transition login-page" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="login-box">
        <div className="card card-outline card-primary">
          <div className="card-header text-center"> <a href="/" className="h4" style={{ display: "block" }}><b>ADMIN LOGIN</b></a></div>
          <div className="card-body" style={{ paddingBottom: 0 }}>
            <p className="login-box-msg">Sign in to start your session</p>
            <form onSubmit={(e) => {
              e.preventDefault();
              if (loading) return;
              //change admin username and password
              if (userid.trim().toLowerCase() === "user" && inputpwd === "1tvmship/") {
                setLoading(true);
                // window.alert("Login Successful");
                if (window.showPreloader) {
                  window.showPreloader();
                }
                try { localStorage.setItem('auth', 'true'); } catch (e) {}
                navigate("/home", { state: { toast: 'Login Successful' } });
              } else {
                try { localStorage.removeItem('auth'); } catch (e) {}
                window.alert("Invalid credentials");
              }
            }}>
              <div className="input-group mb-3">
                <input type="text" className="form-control" placeholder="Username" name="userid" required value={userid} onChange={(e) => setuserid(e.target.value)} />
                <div className="input-group-append">
                  <div className="input-group-text"><span className="fas fa-envelope"></span></div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input type="password" className="form-control" placeholder="Password" name="inputpwd" required value={inputpwd} onChange={(e) => setInputpwd(e.target.value)} />
                <div className="input-group-append">
                  <div className="input-group-text"><span className="fas fa-lock"></span></div>
                </div>
              </div>
              <div className="row">
                <div className="col-8" />
                <div className="col-12">
                  <button type="submit" className="btn btn-primary btn-block mb-1" disabled={loading}>
                    {loading ? (<><i className="fa fa-spinner fa-spin mr-2"></i> Signing in...</>) : "Sign In"}
                  </button>
                  <a href="/" className="btn btn-success btn-block mb-4">Back to Home</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
